import * as React from 'react';
import { Button, Description, Input, Label, Modal, TextField } from '@heroui/react';
import { RacDialogTriggerAnchor } from '@/components/RacDialogTriggerAnchor';

export interface CategoryFormPayload {
  id?: string | null;
  name: string;
}

const FORM_ID = 'qnaire-category-form';

export interface CategoryFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  category?: CategoryFormPayload | null;
  loading?: boolean;
  onSubmit: (payload: CategoryFormPayload) => void;
}

export function CategoryForm({ open, onOpenChange, category, loading = false, onSubmit }: CategoryFormProps) {
  const [name, setName] = React.useState('');
  const isEdit = Boolean(category?.id);
  const onOpenChangeRef = React.useRef(onOpenChange);
  onOpenChangeRef.current = onOpenChange;

  const handleModalOpenChange = React.useCallback((next: boolean) => {
    if (!next) onOpenChangeRef.current(false);
  }, []);

  React.useEffect(() => {
    setName(category?.name ?? '');
  }, [category, open]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || loading) return;
    onSubmit({ id: category?.id ?? null, name: trimmed });
    onOpenChange(false);
  };

  return (
    <Modal isOpen={open} onOpenChange={handleModalOpenChange}>
      <RacDialogTriggerAnchor />
      <Modal.Backdrop>
        <Modal.Container placement="center" scroll="inside" size="md">
          <Modal.Dialog className="w-[min(100vw-2rem,480px)] sm:max-w-[480px]">
            <Modal.Header className="gap-1">
              <Modal.Heading>{isEdit ? '编辑分类' : '新建分类'}</Modal.Heading>
              <Description className="text-sm">
                为问卷分类输入一个易于识别的名称，方便快速整理与检索
              </Description>
            </Modal.Header>
            <Modal.Body>
              <form id={FORM_ID} onSubmit={handleSubmit} className="space-y-4">
                <TextField className="w-full" isDisabled={loading} isRequired>
                  <Label htmlFor="category-name">分类名称</Label>
                  <Input
                    id="category-name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="例如：年度调研、满意度调查..."
                  />
                </TextField>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button type="button" variant="ghost" onPress={() => onOpenChange(false)} isDisabled={loading}>
                取消
              </Button>
              <Button type="submit" form={FORM_ID} variant="primary" isDisabled={loading}>
                {isEdit ? '保存' : '创建'}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
